import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'torchJobTitles'
})
export class TorchJobTitlePipe implements PipeTransform {

  private jobTitles = {
    'Materiel Inventory Sp': 'Materiel Inventory Specialist',
    'Materiel Data Mgmt Spe': 'Materiel Data Management Specialist',
    'Configuration and Data Mg': 'Configuration and Data Management',
    'Warranty Mgmt Spec': 'Warranty Management Specialist'
  };

  transform(value: string, ...args: unknown[]): string {
    let returnValue = value;

    Object.keys(this.jobTitles).forEach(key => {
      returnValue = returnValue.replace(key, this.jobTitles[key]);
    });

    return  returnValue;
  }

}
